import {Component, OnInit, ViewChild} from '@angular/core';
import {NgbModal, NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";
import {BankAccountProvider} from "../../../../providers/company/bank_account/bank_account";
import {MemberProvider} from "../../../../providers/company/member/member";
import {DateUtil} from "../../../../util/dateUtil";
import {ErrorUtil} from "../../../../util/error";
import {PropertyProvider} from "../../../../providers/company/property/property";
import {ContaBancariaDTO} from "../../../../model/dto/ContaBancariaDTO";
import {PessoaFiscalDTO} from "../../../../model/dto/PessoaFiscalDTO";
import {ImovelDTO} from "../../../../model/dto/ImovelDTO";
import * as moment from "moment";
import {FormControl} from "@angular/forms";
import {TreeGridComponent} from "@syncfusion/ej2-angular-treegrid";
import {TreeTableAnual} from "./treeTable";
import {ExcelExportProperties} from "@syncfusion/ej2-grids";
import {Snackbar} from "../../../../util/snackbar";
import {AnnualCharts} from "./charts";
import {ModalExportComponent} from "../modal-export/modal-export.component";
import {ReportsUtil} from "../../../../util/Reports";
import {Chart} from "chart.js";
import {ProcessComparativoChart} from "../chartProcessingUtil/process-comparativo-chart";
import {ExportPdfWithChartImages} from "../chartProcessingUtil/export-pdf-with-chart-images";
import {ProdNameBuilder} from "../prod-name-builder";

@Component({
  selector: 'app-comparativo-anual',
  templateUrl: './comparativo-anual.component.html',
  styleUrls: ['./comparativo-anual.component.scss'],
})
export class ComparativoAnualComponent implements OnInit {

  @ViewChild('grid', {static: false}) public treegrid: TreeGridComponent;
  @ViewChild('treegridCollapse', {static: false}) public treeGridCollapse: TreeGridComponent;

  public contas: ContaBancariaDTO[];
  public socios: PessoaFiscalDTO[];
  public imoveis: ImovelDTO[];

  public bankAccount = new FormControl();
  public property = new FormControl();
  public members = new FormControl();

  public toolbarOptions: any[];
  public years: any;
  public ano: number;
  public ano2: number;
  public deducao: any;
  public filterSettings: any;

  public headers = []
  public data: any[] = [];
  public childMapping = 'children';

  public panelExpanded: boolean = true;
  public changed: boolean = false;

  public links = ['Receita', 'Despesa'];
  // @ts-ignore
  public activeLink: 'Receita' | 'Despesa' = this.links[0];
  private bodyPDF: any[];

  constructor(public modalService: NgbModal,
              public dateUtil: DateUtil,
              public snackBar: Snackbar,
              public treeTable: TreeTableAnual,
              public charts: AnnualCharts,
              public reportsUtil: ReportsUtil,
              private contasProvider: BankAccountProvider,
              private memberProvider: MemberProvider,
              private errorUtil: ErrorUtil,
              private propertyProvider: PropertyProvider,
              private processComparativoChart: ProcessComparativoChart,
              private exportPdfChartWithImages: ExportPdfWithChartImages,
              private prodNameBuilder: ProdNameBuilder) {
  }

  ngOnInit() {
    this.charts.byAccountAux = [];
    this.charts.byAccount = [];
    this.charts.hidden = true;
    this.treeTable.data = [];
    this.treeTable.aux = [];
    this.defaultConfiguration();
    this.initializeData();
  }

  initializeData() {
    this.treeTable.consultando = true;
    this.contasProvider.getAllBanksAccounts().then((accounts: ContaBancariaDTO[]) => {
      this.contas = accounts;
      this.contas.push({id: null, description: 'Sem conta', bankId: null, code: null, countryId: null, agencyWithoutDV: null, accountNumberWithDV: null, bankDTORespComp: null, countryDTORespComp: null, default: false});
      this.memberProvider.getAllMembers().then((members: PessoaFiscalDTO[]) => {
        this.socios = members;
        this.propertyProvider.getAllProperty().then((properties: ImovelDTO[]) => {
          this.imoveis = properties;
          this.initialSelects();
        }).catch(result => {
          this.errorUtil.checkErrorStatus(result, result.status, result.error, 'relatorios-consolidacao');
        });
      });
    });
  }

  defaultConfiguration() {
    this.years = getYears(+moment().format('YYYY') - 20);
    this.ano = +moment(this.dateUtil.removeTimeZone(localStorage.getItem('workDate'))).subtract(1, 'years').format('YYYY');
    this.ano2 = +moment(this.dateUtil.removeTimeZone(localStorage.getItem('workDate'))).format('YYYY');
    this.deducao = 'TODOS';
    this.toolbarOptions = [
      {
        text: 'Exportar', tooltipText: 'Exportar',
        prefixIcon: 'e-pdfexport',
        id: 'Export'
      },
    ];
    this.filterSettings = {type: 'Excel'};
  }

  updateChanged() {
    this.changed = true;
  }

  tabsTypeFilter() {
    if (this.ano === this.ano2) {
      this.snackBar.openLong('Os anos devem ser diferentes!', 'erro');
      return;
    }
    this.changed = false;

    const members = this.members.value.length ? this.members.value.map(value => value.cpfCNPJ) : this.socios.map((value) => value.cpfCNPJ);
    const properties = this.property.value.length ? this.property.value.map(value => value.propertyCode) : this.imoveis.map((value) => value.propertyCode);
    const bankAccount = this.bankAccount.value.length ? this.bankAccount.value.map(value => value.id) : this.contas.map((value) => value.id);

    const realeseType = this.deducao === 'DEDUTIVEIS' ? 1 : this.deducao === 'NAODEDUTIVEIS' ? 2 : 0;

    this.headers = [this.ano.toString(), this.ano2.toString()];

    this.treeTable.getReport(this.ano.toString(), this.ano2.toString(), bankAccount, properties, members, realeseType);

    const column = this.treegrid.grid.getColumnByField('ano1');
    column.headerText = this.ano.toString();
    const column2 = this.treegrid.grid.getColumnByField('ano2');
    column2.headerText = this.ano2.toString();
    this.treegrid.refreshHeader();
  }

  limpaMembers(bool) {
    if (bool) {
      this.members.setValue(this.socios);
    } else {
      this.members.setValue([])
    }
  }

  limpaImoveis(bool) {
    if (bool) {
      this.property.setValue(this.imoveis)
    } else {
      this.property.setValue([])
    }
  }

  limpaConta(bool) {
    if (bool) {
      this.bankAccount.setValue(this.contas)
    } else {
      this.bankAccount.setValue([])
    }
  }

  initialSelects() {
    this.members.setValue([])
    this.property.setValue([])
    this.bankAccount.setValue([])
    this.treeTable.start();
  }

  collapseTable() {
    if (this.childMapping != 'children') {
      this.childMapping = 'children';
      this.treegrid.expandAtLevel(0);
    } else {
      this.childMapping = null;
      this.treegrid.collapseAtLevel(0);
    }
  }

  toolbarClick(args: any): void {
    if (args.item.id === 'Export') {
      let modalOptions: NgbModalOptions = {
        backdrop: 'static',
        windowClass: localStorage.getItem('theme') == 'dark' ? 'dark-theme' : '',
      };
      const modalRef = this.modalService.open(ModalExportComponent, modalOptions);
      modalRef.componentInstance.relatorio = 'comparativo-anual';
      modalRef.componentInstance.texto = "as despesas ou receitas de cada conta no ano";
      modalRef.result.then((result: any) => {
        if (result.type === 'pdf') {
          this.exportPDF(result.img);
        } else if (result.type === 'excel') {
          this.exportExcel();
        }
      });
    }
  }

  exportPDF(img: boolean) {
    const date = moment().format('DD/MM/YY HH:mm').toString();

    let properties = 'Todos os imóveis';
    if (this.property.value != null) {
      if (!(this.property.value.length == this.imoveis.length || this.property.value.length == 0)) {
        let tmp = [];
        this.property.value.forEach((value) => {
          tmp.push(value.propertyCode);
        });
        properties = (tmp.length > 1) ? tmp.join(', ') : tmp[0];
      }
    }

    let accounts = 'Todas as contas';
    if (this.bankAccount.value != null) {
      if (!(this.bankAccount.value.length == this.contas.length || this.bankAccount.value.length == 0)) {
        let tmp = [];
        this.bankAccount.value.forEach((value) => {
          tmp.push(value.description);
        });
        accounts = (tmp.length > 1) ? tmp.join(', ') : tmp[0];
      }
    }

    let members = 'Todos os produtores';
    if (this.members.value != null) {
      if (!((this.members.value.length == this.socios.length && this.members.value.length != 1) || this.members.value.length == 0)) {
        let tmp = [];
        this.members.value.forEach((value) => {
          tmp.push({name: value.name, cpfCNPJ: value.cpfCNPJ});
        });
        members = this.prodNameBuilder.build(tmp);
      }
    }

    let deducao: string;
    if (this.deducao === 0) {
      deducao = 'Todos os valores';
    } else if (this.deducao === true) {
      deducao = 'Dedutíveis';
    } else {
      deducao = 'Não dedutíveis';
    }

    let headers = [
      {dataKey: 'conta', header: 'Conta'},
      {dataKey: 'ano1', header: this.ano},
      {dataKey: 'ano2', header: this.ano2},
      {dataKey: 'porcento', header: 'Diferença (%)'},
      {dataKey: 'absoluto', header: 'Diferença (R$)'}
    ];

    let colunas = [
      {dataKey: 'conta', cellWidth: 9},
      {dataKey: 'ano1', minCellWidth: 1.5, halign: 'center'},
      {dataKey: 'ano2', minCellWidth: 1.5, halign: 'center'},
      {dataKey: 'porcento', minCellWidth: 1.5, halign: 'center'},
      {dataKey: 'absoluto', minCellWidth: 1.5, halign: 'center'},
    ];

    this.bodyPDF = [];
    this.processBodyPDF(this.treeTable.data, this.childMapping == 'children');

    this.reportsUtil.exportPDF({
      doc: {
        arquivo: `Comparativo anual - ${this.ano} e ${this.ano2}`,
        orientacao: 'Landscape',
      },
      cabecalho: {
        titulo: `Comparativo Anual`,
        data: date,
        periodo: this.ano.toString() + ' e ' + this.ano2.toString(),
        parametros: {
          "Dedução": deducao,
          "Imóveis": properties,
          "Produtores": members,
          "Contas": accounts,
        },
        image: img,
      },
      tabela: {
        dados: this.bodyPDF,
        colunas: headers,
        estiloColunas: colunas,
        hierarquico: true
      },
    });
  }

  exportExcel() {
    const exportProperties: ExcelExportProperties = {
      includeHiddenColumn: true,
      fileName: `Comparativo anual - ${this.ano} e ${this.ano2}.xlsx`,
    };
    if (this.childMapping == 'children') {
      this.treegrid.excelExport(exportProperties);
    } else {
      this.treeGridCollapse.excelExport(exportProperties);
    }
  }

  processBodyPDF(data, children, depth = 0) {
    data.forEach((item) => {
      let tmp = {
        conta: "  ".repeat(depth * 2) + item.conta,
        ano1: this.formatNumber(item.ano1),
        ano2: this.formatNumber(item.ano2),
        absoluto: this.formatNumber(item.absoluto),
        porcento: this.formatPercent(item.porcento),
        depth: depth,
        children: item.children.length > 0
      };

      this.bodyPDF.push(tmp);

      if (item.children.length > 0 && children) {
        this.processBodyPDF(item.children, true, depth + 1);
      }
    });
  }

  amountIsPositive(value): boolean {
    return +value >= 0;
  }

  formatNumber(value) {
    return Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(Math.abs(value));
  }

  formatPercent(number) {
    return number.toFixed(2).replace(".", ",") + '%';
  }

  /*
  01/09/2025 - Kauan
  esse condicional baseado no chart.data.datasets.length ta aqui pq o chartjs é meio bugado e nao apaga as instancias caso o user nao de f5 na pagina
  nesse caso ele só aceita graficos cujo dataset seja igual a dois (ja que esse numero de datasets só existe nesse grafico dentro de toda a aplicacao
  caso outro com o mesmo numero de datasets seja adicionado é necessario refatorar esse if
  */
  exportChartImagesAsPdf(logoPresent: boolean){
    let instances : number [] = [];

    Chart.helpers.each(Chart.instances, (instance: any) => {
      if (instance.chart.data.datasets.length === 2
        && instance.chart.width !== 497
      ){
        instances.push(instance.id);
      }
    });

    this.charts.exportando = true;
    let div0 = document.getElementById('divChart0');
    let div1 = document.getElementById('divChart1');
    div0.style.display = 'none';
    div1.style.display = 'none';

    this.processComparativoChart.process(Chart.instances[instances[0]], Chart.instances[instances[0]].canvas.id);

    //nao da pra iterar sobre os graficos como nos outros relatorios pq sao do mesmo formato e utilizam o mesmo metodo.
    //imagino que por causa dos timeouts do metodo, aí na hora de reestabelecer os valores previos
    //o this.datasets fica igual e portanto ambos os graficos ficam iguais também. Acho que é pq o angular usa singleton pras classes
    setTimeout(() => {
      this.processComparativoChart.process(Chart.instances[instances[1]], Chart.instances[instances[1]].canvas.id);
    }, 700);

    let yearArray : any [] = [];
    yearArray.push(this.ano);
    yearArray.push(this.ano2);
    yearArray.sort((a, b) => a - b);

    const empresa = localStorage.getItem('empresa');

    setTimeout(()=> {
      this.exportPdfChartWithImages.exportTwoBars('Gráficos - Comparativo Anual', `comparativo_anual_graficos_${empresa.toLowerCase().replace(' ','_')}_${yearArray[0]}-${yearArray[1]}`, `${yearArray[0]} - ${yearArray[1]}`, logoPresent);
    }, 900);

    setTimeout(() => {
      div0.style.display = '';
      div1.style.display = '';
      this.charts.exportando = false;
    }, 1400)
  }
}

function getYears(startYear) {
  const currentYear = new Date().getFullYear() + 1, years = [];
  startYear = startYear || 1980;
  while (startYear <= currentYear) {
    years.push(startYear++);
  }
  return years;
}
